import { NgModule } from '@angular/core';
import { AddonsBarComponent } from './addons-bar.component';
import { AngularSharedUtilsCoreModule } from '@herrenknecht-connected/angular-shared-utils-core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { AppFrameMobileComponent } from './app-frame-mobile.component';
import { AppFrameComponent } from './app-frame.component';
import { NotificationsOverlayComponent } from './notifications-overlay.component';
import { TopBarComponent } from './top-bar.component';
import { SidenavMenuEntryComponent } from './sidenav-entry.component';
import { SidenavMenuComponent } from './sidenav-menu.component';
import { FullscreenContainerComponent } from './fullscreen-container.component';
import { FullscreenContainerContentDirective } from './fullscreen-container-content.directive';
import { SidenavComponent } from './sidenav.component';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLineModule } from '@angular/material/core';
import { ProductLayoutComponent } from './product-layout.component';
import {
  CenteredMatSpinnerComponent,
  HKButtonDirective,
  IconWithLabelComponent,
  LayoutContainerComponent,
  TextComponent,
} from '@herrenknecht-connected/angular-shared-ui-base-components';

const components = [
  AddonsBarComponent,
  AppFrameMobileComponent,
  AppFrameComponent,
  NotificationsOverlayComponent,
  TopBarComponent,
  SidenavMenuEntryComponent,
  SidenavMenuComponent,
  FullscreenContainerComponent,
  FullscreenContainerContentDirective,
  SidenavComponent,
  ProductLayoutComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    AngularSharedUtilsCoreModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule,
    RouterLink,
    AngularSvgIconModule,

    MatExpansionModule,
    MatListModule,
    MatBadgeModule,
    MatProgressBarModule,
    MatLineModule,
    RouterOutlet,
    CenteredMatSpinnerComponent,
    TextComponent,
    IconWithLabelComponent,
    HKButtonDirective,
    LayoutContainerComponent,
  ],
  exports: components,
})
export class AngularSharedFeatureAppFrameModule {}
